import { render, staticRenderFns } from "./SpecialistsList.vue?vue&type=template&id=e317247a&"
import script from "./SpecialistsList.vue?vue&type=script&lang=js&"
export * from "./SpecialistsList.vue?vue&type=script&lang=js&"
import style0 from "./SpecialistsList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports